import { path } from 'ramda'

export const getNestedProp = (key, target) => path(key.split('.'), target)



// WEBPACK FOOTER //
// ./src/utils/ramda/index.js